import { render, staticRenderFns } from "./ModalReclamation.vue?vue&type=template&id=21239f0b"
import script from "./ModalReclamation.vue?vue&type=script&lang=js"
export * from "./ModalReclamation.vue?vue&type=script&lang=js"
import style0 from "./ModalReclamation.vue?vue&type=style&index=0&id=21239f0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports